import React from "react";
import { Routes, Route } from "react-router-dom";
import DashboardDetail from "./dashboard-detail";

//
const Dashboard = () => {
  return (
    <React.Fragment>
      <Routes>
        <Route path="" element={<DashboardDetail />} />
         <Route path="/" element={<DashboardDetail />} />
      </Routes>
    </React.Fragment>
  );
};

export default Dashboard;
